import { isPresent, unwrapMaybe } from '@karakuri-web/common/utils'
import { AnswerAction, AnswerAsk } from '@karakuri-web/faq-type'

import { Query, Session } from './interface'

export const getOperatorEscalationQueriesForAnswer = ({
  cardId,
  answers,
  selectionPath,
  operatorEscalationKeyword,
}: {
  cardId: string
  answers: AnswerAsk[]
  selectionPath: string[]
  operatorEscalationKeyword: string
}): Query[] => {
  const queries: Query[] = selectionPath
    .filter(x => x !== cardId)
    .map(x => {
      const selected = answers
        .filter(a => !!(a?.actions?.actions || []).some(action => action?.id === x))
        .map(_ => _.actions)[0]
      if (!selected) {
        return {} as Query
      }
      const selectedAction = (selected?.actions || []).find(action => action?.id === x)
      return {
        action: selectedAction?.id,
        answer: selected.id,
        card: cardId,
        displayText: unwrapMaybe(selectedAction?.label),
      }
    })
    .filter(x => !!x)

  const asks = answers
    .filter(x => x.id === cardId)
    .map(x => x.ask)
    .filter(isPresent<string>)
  return [...asks, ...queries, operatorEscalationKeyword]
}

export const getOperatorEscalationUrlForAnswer = ({
  cardId,
  answers,
  selectionPath,
  karakuriWebRootUrl,
  operatorEscalationKeyword,
  session,
}: {
  cardId: string
  answers: AnswerAsk[]
  selectionPath: string[]
  karakuriWebRootUrl: string
  operatorEscalationKeyword: string
  session: Session
}) => {
  const queries = getOperatorEscalationQueriesForAnswer({
    cardId,
    answers,
    selectionPath,
    operatorEscalationKeyword,
  })

  let referrer = ''
  if (typeof window !== 'undefined') {
    referrer = `&referrer=${encodeURIComponent(window.location.href)}`
  }

  return `${karakuriWebRootUrl}/embed/?queries=${encodeURIComponent(JSON.stringify(queries))}${
    session.value ? `&session=${encodeURIComponent(session.value)}` : ''
  }${referrer}`
}

export const getOperatorEscalationQueryForAction = ({
  action,
  operatorEscalationKeyword,
}: {
  action: AnswerAction
  operatorEscalationKeyword: string
}): Query => {
  if (action.isOperatorConnect) {
    if (action.label === operatorEscalationKeyword) {
      return operatorEscalationKeyword
    } else {
      return { operator: 'connect', displayText: unwrapMaybe(action.label) }
    }
  } else {
    return ''
  }
}

export const getOperatorEscalationUrlForAction = ({
  action,
  karakuriWebRootUrl,
  operatorEscalationKeyword,
  session,
}: {
  action: AnswerAction
  karakuriWebRootUrl: string
  operatorEscalationKeyword: string
  session: Session
}) => {
  const query = getOperatorEscalationQueryForAction({
    action,
    operatorEscalationKeyword,
  })
  const queries = query === '' ? [] : [query]

  let referrer = ''
  if (typeof window !== 'undefined') {
    referrer = `&referrer=${encodeURIComponent(window.location.href)}`
  }

  return `${karakuriWebRootUrl}/embed/?queries=${encodeURIComponent(JSON.stringify(queries))}${
    session.value ? `&session=${encodeURIComponent(session.value)}` : ''
  }${referrer}`
}
